import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M35.9496 4.86426H12.2604C8.16024 4.86426 4.83643 8.18807 4.83643 12.2882V35.9774C4.83643 40.0775 8.16024 43.4013 12.2604 43.4013H35.9496C40.0497 43.4013 43.3735 40.0775 43.3735 35.9774V12.2882C43.3735 8.18807 40.0497 4.86426 35.9496 4.86426Z",
			fill: "url(#paint0_linear_198_9931)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 10.2204,
			y: 9.57094,
			width: 51.8034,
			height: 51.8034,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.32px)",
					clipPath: "url(#bgblur_0_198_9931_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 6.63316,
			d: "M24.2774 16.7041H47.9666C51.7906 16.7041 54.8906 19.8041 54.8906 23.628V47.3172C54.8906 51.1412 51.7906 54.2412 47.9666 54.2412H24.2774C20.4535 54.2412 17.3535 51.1412 17.3535 47.3172V23.628C17.3535 19.8041 20.4535 16.7041 24.2774 16.7041Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_198_9931)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_9931_clip_path",
				transform: "translate(-10.2204 -9.57094)",
				children: /* @__PURE__ */ _jsx("path", { d: "M24.2774 16.7041H47.9666C51.7906 16.7041 54.8906 19.8041 54.8906 23.628V47.3172C54.8906 51.1412 51.7906 54.2412 47.9666 54.2412H24.2774C20.4535 54.2412 17.3535 51.1412 17.3535 47.3172V23.628C17.3535 19.8041 20.4535 16.7041 24.2774 16.7041Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_9931",
				x1: 43.3735,
				y1: 24.1328,
				x2: 4.83643,
				y2: 24.1328,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_9931",
				x1: 14.9267,
				y1: 18.9567,
				x2: 42.7849,
				y2: 61.5039,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgLayers);
export { ForwardRef as ReactComponent };
